<template>
  <div class="register1-content">
    <AlertMessages />
    <form @submit.prevent="register">
      <fieldset>
        <legend class="page-title">Personal Information</legend>
        <div class="form-row">
          <div class="col-12 col-lg-6">
            <div class="field-wrapper" v-flyout>
              <input
                class="text-field-1"
                id="firstName"
                autocomplete="given-name"
                      aria-label="First Name"
                      aria-required="true"
                      :aria-invalid="$v.FirstName.$error"
                      aria-errormessage="errorFirstName"
                v-model="FirstName"
                @blur="$v.FirstName.$touch()"
                :class="{ 'is-invalid': $v.FirstName.$error }"
              />
              <i class="fa fa-check"></i>
              <div class="field-placeholder" v-animate>
                <span class="asterisk">First name</span>
              </div>
            </div>
            <div id="errorFirstName" v-if="$v.FirstName.$error" class="feedback">
              <span v-if="!$v.FirstName.required"> This field is required</span>
              <span v-if="!$v.FirstName.minLength"
                >First name must be at least 2 characters</span
              >
              <span v-if="!$v.FirstName.maxLength"
                >First name must be less than 100 characters</span
              >
              <span v-if="!$v.FirstName.characters"
                >Characters and alphabets, hyphens and numbers are allowed</span
              >
            </div>
          </div>

          <div class="col-12 col-lg-6">
            <div class="field-wrapper" v-flyout>
              <input
                class="text-field-1"
                id="lastName"
                autocomplete="family-name"
                      aria-label="Last Name"
                      aria-required="true"
                      :aria-invalid="$v.LastName.$error"
                      aria-errormessage="errorLastName"
                v-model="LastName"
                @blur="$v.LastName.$touch()"
                :class="{ 'is-invalid': $v.LastName.$error }"
              />
              <i class="fa fa-check"></i>
              <div class="field-placeholder" v-animate>
                <span class="asterisk">Last name</span>
              </div>
            </div>
            <div id="errorLastName" v-if="$v.LastName.$error" class="feedback">
              <span v-if="!$v.LastName.required">This field is required</span>
              <span v-if="!$v.LastName.minLength"
                >Last name must be at least 2 characters</span
              >
              <span v-if="!$v.LastName.maxLength"
                >Last name must be less than 100 characters</span
              >
              <span v-if="!$v.LastName.characters"
                >Characters and alphabets, hyphens and numbers are allowed</span
              >
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12">
            <div class="field-wrapper" v-flyout>
              <input
                type="text"
                autocomplete="email"
                class="text-field-4"
                id="email"
                      aria-label="Email address"
                      aria-required="true"
                      :aria-invalid="$v.Email.$error"
                      aria-errormessage="errorEmail"
                v-model="Email"
                @blur="$v.Email.$touch()"
                :class="{ 'is-invalid': $v.Email.$error }"
              />
              <i class="fa fa-check"></i>
              <div class="field-placeholder" v-animate>
                <span class="asterisk">Email address</span>
              </div>
            </div>
            <div id="errorEmail" v-if="$v.Email.$error" class="feedback">
              <span v-if="!$v.Email.required">This field is required</span>
              <span v-if="!$v.Email.email && $v.Email.$dirty"
                >Incorrect email format</span
              >
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12">
            <div class="field-wrapper" v-flyout>
              <input
                type="text"
                autocomplete="email"
                class="text-field-4"
                id="confirmEmail"
                      aria-label="Confirm Email address"
                      aria-required="true"
                      :aria-invalid="$v.ConfirmEmail.$error"
                      aria-errormessage="errorConfirmEmail"
                v-model="ConfirmEmail"
                @blur="$v.ConfirmEmail.$touch()"
                :class="{ 'is-invalid': $v.ConfirmEmail.$error }"
              />
              <i class="fa fa-check"></i>
              <div class="field-placeholder" v-animate>
                <span class="asterisk">Confirm email address</span>
              </div>
            </div>
            <div id="errorConfirmEmail" v-if="$v.ConfirmEmail.$error" class="feedback">
              <span v-if="!$v.ConfirmEmail.required"
                >This field is required</span
              >
              <span v-if="!$v.ConfirmEmail.email && $v.ConfirmEmail.$dirty"
                >Incorrect email format</span
              >
              <span v-if="!$v.ConfirmEmail.sameAsEmail">Emails must match</span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12">
            <div class="field-wrapper" v-flyout>
              <input
                type="password"
                autocomplete="new-password"
                class="text-field-4"
                id="password"
                      aria-label="Password"
                      aria-required="true"
                      :aria-invalid="$v.Password.$error"
                      aria-errormessage="errorPassword"
                      aria-describedby="passwordFormatDetails"
                ref="password"
                v-model="Password"
                @blur="$v.Password.$touch()"
                :class="{ 'is-invalid': $v.Password.$error }"
              />
              <i @click.prevent="showPassword" :class="iconId"></i>
<i class="fa fa-check"></i>
              <div class="field-placeholder" v-animate>
                <span class="asterisk">Password</span>
              </div>
            </div>
            <div id="errorPassword" v-if="$v.Password.$error" class="feedback">
              <span v-if="!$v.Password.required">This field is required</span>
              <span v-if="!$v.Password.minLength"
                >Password must be at least 8 characters</span
              >
              <span v-if="!$v.Password.strongPassword"
                >Password must contain a lowercase character, uppercase
                character, a number and a special character</span
              >
            </div>
            <p id="passwordFormatDetails" class="label-info">
              Must be at least 8 characters and contain a lowercase character,
              uppercase character, a number and a special character.
            </p>
          </div>
        </div>
      </fieldset>
      <div class="form-row cta-group flex-column flex-column-md-reverse flex-md-row">
          <button role="button" class="cta-white-203">
              Go to final step<span class="angle-right-white"></span>
          </button>
          <router-link role="navigation" class="back-link" :to="{ name: 'signin' }">
              <span class="angle-left-green"></span>
              Back to sign in
          </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import {
  required,
  email,
  sameAs,
  minLength,
  maxLength,
  helpers
} from "vuelidate/lib/validators";
//import { publicRouter } from "../router";
import AlertMessages from "../components/alert-messages";
import { SET_USER } from "../store/mutation-types";

// characters and alphabets, hyphens and numbers only
const characters = helpers.regex(
  "characters",
  /^[0-9a-zA-Z\u00C0-\u024F\u1E02-\u1EF3'\- ]+$/
);

export default {
  name: "RegisterStep1",
  components: { AlertMessages },
  data() {
    return {
      showEyeIcon: false
    };
  },
  validations: {
    FirstName: {
      required,
      maxLength: maxLength(100),
      minLength: minLength(2),
      characters
    },
    LastName: {
      required,
      maxLength: maxLength(100),
      minLength: minLength(2),
      characters
    },
    Email: {
      required,
      email
    },
    ConfirmEmail: {
      required,
      sameAsEmail: sameAs("Email")
    },
    Password: {
      required,
      minLength: minLength(8),
      strongPassword: password => {
        if (
          typeof password == "undefined" ||
          password == null ||
          password == ""
        )
          return true;
        return (
          //          password.length >= 8 &&
          /[a-z]/.test(password) &&
          /[A-Z]/.test(password) &&
          /[0-9]/.test(password) &&
          /[!@#$%^&*(),.?":{}|<>]/.test(password)
        );
      }
    }
  },
  created() {
    this.RegistrationStatus = 1;
  },
  methods: {
    ...mapActions("users", ["createUser"]),
    ...mapActions("alert", ["clear"]),
    showPassword() {
      this.showEyeIcon = !this.showEyeIcon;
      if (this.$refs.password.type == "password") {
        this.$refs.password.type = "text";
      } else {
        this.$refs.password.type = "password";
      }
    },
    async register() {
      this.clear();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.RegistrationStatus = 1;
      
      await this.createUser({
        user: this.user,
        regStatus: this.RegistrationStatus
      });
      if (!this.hasError && this.Id != null) {
        //publicRouter.push("/register-step2");
        //  publicRouter.push("/register");

        this.$emit("clicked", "1");
      }
    }
  },
  computed: {
    ...mapState("users", ["user"]),
    ...mapGetters("alert", ["hasError"]),
    iconId() {
      return this.showEyeIcon ? "eye-on" : "eye-off";
    },
    RegistrationStatus: {
      get() {
        return this.user.RegistrationStatus;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { RegistrationStatus: val });
      }
    },
    Id: {
      get() {
        return this.user.Id;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Id: val });
      }
    },
    FirstName: {
      get() {
        return this.user.FirstName;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { FirstName: val });
        //this.$v.firstName.$touch();
      }
    },
    LastName: {
      get() {
        return this.user.LastName;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { LastName: val });
      }
    },
    Email: {
      get() {
        return this.user.Email;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Email: val });
      }
    },
    ConfirmEmail: {
      get() {
        return this.user.ConfirmEmail;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { ConfirmEmail: val });
      }
    },
    Password: {
      get() {
        return this.user.Password;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Password: val });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
